export default function () {
    function build(entity) {
        if (!entity) throw Error('No supplied entity.');
        return {
            ...entity,
            entity: 'Event',
            event_route: eventRoute(entity),
        };
    }

    async function get(eventSlug) {
        let event = null,
            error = null;
        try {
            const {data} = await useApi('videos').get('events/' + eventSlug);
            event = build(data.event);
        } catch (e) {
            error = useApiError(e);
        }
        return {event, error};
    }

    function eventRoute(entity) {
        if (!entity.event_slug) return undefined;
        return {
            name: 'events-eventSlug',
            params: {
                eventSlug: entity.event_slug,
            },
        };
    }

    return {build, get};
}
